import React from 'react';
import AboutTemplate from './AboutTemplate';
import { platformData } from './platformData';

const OncoRiskAbout = () => {
  return (
    <AboutTemplate 
      {...platformData.oncorisk}
      platformKey="oncorisk"
    />
  );
};

export default OncoRiskAbout; 